import { callAppAPI } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { ContactServiceData } from "src/pages/contactservice/useValidationSchemaContactService";

export type LabelDto = {
  key: string,
  value: string,
};

export const fetchContactServicesListServices = async (locale: string, agence: string) => {
  return callAppAPI<LabelDto[]>({
    method: "GET",
    url: DictionnaireApi.contactServiceListService.getUrl(locale, agence),
  })
    .then(result => {
      return result;
    })
    .catch(err => {
      console.log("Error : " + err);
      return null;
    });
};


export const sendContactServiceForUser = async (values: ContactServiceData) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.contactServiceUser.getUrl(),
    data: { ...values },
  });
};

export const sendContactServiceForAffilie = async (uuidEmployeur: string, values: ContactServiceData) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.contactServiceAffilie.getUrl(uuidEmployeur),
    data: { ...values },
  });

};
